import axios from 'axios'
const uri = 'consultas-facturacion/php/api/'

const get = (url) => {
	return axios.get(uri + url)
}

const post = (url, data) => {
	return axios.post(uri + url, data)
}

export default {
	getCamposFormulario () {
		return get('porAgente/get-formulario.php')
	},

	getAgentesActivos () {
		return get('porAgente/get-agentes-activos.php')
	},

	consultarPorAgentes (datos) {
		const filtro = _.clone(datos)

		filtro.fecha_ini = (filtro.fecha_ini === null) ? null : Math.floor(filtro.fecha_ini.getTime() / 1000)
		filtro.fecha_fin = (filtro.fecha_fin === null) ? null : Math.floor(filtro.fecha_fin.getTime() / 1000)
		return post('porAgente/consultar.php', filtro)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/consultas-facturacion/vue/components/porAgente/api.js